"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetch = void 0;
/// <reference lib="dom" />
let fetch;
if (typeof globalThis?.fetch !== "undefined") {
    exports.fetch = fetch = globalThis.fetch;
}
else {
    exports.fetch = fetch = require("cross-fetch");
}
//# sourceMappingURL=universal.js.map